import React from "react";
import { FaCheckCircle, FaMinusCircle, FaTimesCircle } from "react-icons/fa";
import "./PasswordRequirement.css"

interface Props {
    id: string;
    requirementMet: boolean;
    invalidMessage: string;
    Disabled?: boolean;
}

const PasswordRequirement = (props: Props) => {
    return (
        <>
            <div
                id={props.id}
                data-testid={props.id}
                className={`saifPasswordRequirement ${props.requirementMet ? "saif-valid" : ""
                    }`}
            >
                <div
                    className={`saifPasswordRequirementCheck`}
                    aria-hidden="true"
                >
                    <i
                        id={`${props.id}-circle`}
                        data-testid={`${props.id}-circle`}
                        className={
                            props.Disabled
                                ? "fas fa-minus-circle fa-s text-slate"
                                : props.requirementMet
                                    ? "fas fa-check-circle fa-s text-evergreen"
                                    : "fas fa-times-circle fa-s text-cherry"
                        }
                    >
                        {props.Disabled ? <FaMinusCircle /> : props.requirementMet ? <FaCheckCircle /> : <FaTimesCircle />}
                    </i>
                </div>
                <div
                    id={`${props.id}-label`}
                    data-testid={`${props.id}-label`}
                    className={`saifPasswordRequirementLabel ${props.Disabled ? "text-slate" : ""
                        }`}
                    aria-hidden="true"
                >
                    {props.invalidMessage}
                </div>
            </div>
        </>
    );
};

export default PasswordRequirement;
